<template>
  <div class="limiter font-example">
    <div class="container-login">
      <v-container fluid class="resultados-container">
        <v-row align="center" justify="center" class="resultados-row">
          <v-col cols="12" class="resultados-col">
            <v-card flat class="resultados-shell">
              <div
                style="margin: 5px; padding: 15px; text-align: center"
                v-if="carregamento == 'CARREGANDO'"
              >
                <p>Carregando questionário...</p>
                <v-progress-linear
                  max-width="100px"
                  indeterminate
                  color="blue"
                ></v-progress-linear>
              </div>
              <div v-if="carregamento == 'CARREGADO'" class="resultados-content">
                <v-card class="transparent-card resultados-card">
                  <v-row dense align="center" justify="center" class="resultados-main">
                    <v-col cols="12" align="center" justify="center">
                      <v-img :src="empresa.avatarUrl" class="resultados-logo" contain>
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="white"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-col>
                    <template v-if="!mostrarResultados">
                      <v-col cols="12" md="8" lg="7" xl="6" align="center" justify="center">
                        <h2 class="resultados-title resultados-title-yellow">
                          SELECIONE A OPÇÃO
                        </h2>
                        <h2 class="resultados-title resultados-title-white">
                          ABAIXO E VEJA
                        </h2>
                        <h2 class="resultados-title resultados-title-yellow resultados-title-last">
                          O RESULTADO DA VOTAÇÃO
                        </h2>
                        <div class="resultados-panel">
                          <v-list class="transparent-list resultados-question-list">
                            <v-list-item
                              v-for="(item, index) in perguntas"
                              :key="item.id"
                              @click="exibeResultado(item.id, item.titulo)"
                              class="list-item resultados-question-item"
                            >
                              <v-list-item-content>
                                <v-list-item-title class="resultados-question-text">
                                  {{
                                    index +
                                    1 +
                                    " - " +
                                    item.titulo
                                      .toUpperCase()
                                      .replace("ESCOLHA A", "A")
                                  }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </div>
                      </v-col>
                    </template>

                    <template v-else>
                      <v-col cols="12" md="11" lg="10" xl="9" align="center" justify="center">
                        <h2 class="resultados-title resultados-title-yellow resultados-results-heading">
                          VOTAÇÃO POPULAR
                        </h2>
                        <h4 class="resultados-subtitle">
                          {{ perguntaTitulo }}
                        </h4>
                        <v-btn class="resultados-back-btn" color="#F9C028" rounded depressed @click="voltarParaPerguntas">
                          Ver outra opção
                        </v-btn>
                        <div class="resultados-ranking">
                          <v-list class="transparent-list resultados-ranking-list">
                            <v-list-item
                              v-for="(item, index) in rankedList"
                              :key="index"
                              class="result-card"
                            >
                              <div class="result-position">{{ index + 1 }}</div>
                              <v-list-item-avatar size="78" class="result-avatar">
                                <v-img :src="item.foto"></v-img>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title class="result-name">
                                  {{ item.escolhaUnica }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="result-votes">
                                  Votos: {{ item.votos }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </div>
                      </v-col>
                    </template>
                  </v-row>
                </v-card>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      color="#00695C"
      :is-full-page="fullPage"
    ></loading>
    <Snackbar ref="chamaSnackbar" />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { baseApiUrl } from "@/global";
import Snackbar from "../../componentes/snackbar.vue";
import { mapState } from "vuex";
import axios from "axios";

export default {
  components: { Snackbar, Loading },
  name: "Auth",
  computed: mapState({
    usuarioLogado: (state) => state.isMenuVisible,
  }),
  data() {
    return {
      isLoading: false,
      fullPage: true,
      carregamento: "",
      questionario: [],
      rankedList: [],
      perguntas: [],
      empresa: [],
      stepper: 1,
      quantidadeHeader: 0,
      mostrarResultados: false,
      perguntaAtualIndex: 0,
      perguntaTitulo: "",
      intervalId: null,
    };
  },
  mounted() {
    this.pegaParametrosUrl();
    setTimeout(() => {
      let number = document.getElementsByClassName("stepperHeader");
      this.quantidadeHeader = number.length;
    }, 1000);
  },
  methods: {
    async pegaParametrosUrl() {
      this.carregamento = "CARREGANDO";
      this.isLoading = true;
      var params = window.location.search.substring(1).split("&");
      if (params[0] != "") {
        var paramArray = {};
        for (var i = 0; i < params.length; i++) {
          var param = params[i].split("=");
          paramArray[param[0]] = param[1];
        }
        if (paramArray["q"]) {
          this.carregaInformacoes(paramArray["q"]);
        }
      }
      this.isLoading = false;
    },

    async carregaInformacoes(questionarioId) {
      await axios.post(baseApiUrl + 'Questionarios/infoQuestionario', {"questionarioId": questionarioId})
      .then(async response => {
        this.questionario = response.data.questionario
        this.empresa = response.data.empresa
        await this.carregaPerguntas(response.data.perguntas)
        this.carregamento = 'CARREGADO'
        this.setPerguntaInterval();
      })
    },

    setPerguntaInterval() {
      if (
        this.questionario.tempoExibicao &&
        this.questionario.tempoExibicao > 0
      ) {
        this.intervalId = setInterval(() => {
          this.togglePergunta();
        }, this.questionario.tempoExibicao);
      }
    },
    
    async exibeResultado(id) {
      await axios.post(baseApiUrl + 'Perguntas/resultados', {"perguntaId": id})
      .then(response => {
        this.rankedList = response.data.resultados;
        this.perguntaTitulo = response.data.titulo;
        this.mostrarResultados = true;
      })
      .catch(() => {
        //
      })
    },
    voltarParaPerguntas() {
      this.mostrarResultados = false;
    },
    verificaEscalaComFoto(lista) {
      for (let i = 0; i < lista.length; i++) {
        if (lista[i].tipo == "ESCOLHA ÚNICA COM FOTO") {
          for (let j = 0; j < lista[i].escolhas.length; j++) {
            lista[i].escolhas[j].selecionado = false;
          }
        }
      }
      return lista;
    },

    async carregaPerguntas(perguntas) {
      perguntas = [...perguntas].sort((a, b) => (Number(a.peso) || 0) - (Number(b.peso) || 0))
      this.perguntaInformativo = perguntas.filter(pergunta => pergunta.tipo === 'INFORMATIVO')

      if (this.perguntaInformativo.length >= 1)
        this.perguntas = perguntas.filter(pergunta => pergunta.id !== this.perguntaInformativo[0].id)
      else
        this.perguntas = perguntas
    },

    togglePergunta() {
      if (this.perguntas.length > 1) {
        this.perguntaAtualIndex =
          (this.perguntaAtualIndex + 1) % this.perguntas.length;
        this.exibeResultado(
          this.perguntas[this.perguntaAtualIndex].id,
          this.perguntas[this.perguntaAtualIndex].titulo
            .toUpperCase()
            .replace("ESCOLHA A", "A")
        );
      }
    },

    beforeDestroy() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: "Montserrat";
  src: url("~@/assets/Montserrat-Medium.ttf") format("opentype");
}
.font-example {
  font-family: "Montserrat", sans-serif;
}
.limiter {
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  background: #080d1b;
  overflow-x: hidden;
}
.container-login {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: clamp(12px, 2vh, 24px);
  background: url("../../assets/votacaoBackground.webp") center / cover no-repeat;
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}
.resultados-container {
  width: 100%;
  max-width: none;
  padding: 0;
}
.resultados-row {
  min-height: calc(100vh - 48px);
  min-height: calc(100dvh - 48px);
}
.resultados-col {
  display: flex;
  justify-content: center;
}
.texto {
  font-weight: bold;
  color: #00253e;
  font-size: 17px;
}
.resultados-shell {
  width: 100%;
  max-width: 1180px;
  background: transparent !important;
  box-shadow: none !important;
}
.resultados-content,
.resultados-card {
  width: 100%;
}
.resultados-card {
  min-height: calc(100vh - 72px);
  min-height: calc(100dvh - 72px);
  display: flex;
  align-items: center;
  background: transparent !important;
  box-shadow: none !important;
}
.resultados-main {
  width: 100%;
  margin: 0;
  text-align: center;
}
.resultados-logo {
  width: min(360px, 72vw);
  max-height: 170px;
  margin: 0 auto clamp(18px, 3vh, 34px);
}
.transparent-list {
  background-color: transparent !important;
}
.transparent-card {
  background-color: transparent !important;
}
.resultados-title {
  margin: 0;
  font-size: clamp(28px, 4vw, 50px);
  line-height: 0.95;
  font-weight: 900;
  text-shadow: 0 4px 14px rgba(0, 0, 0, 0.55);
}
.resultados-title-yellow {
  color: #f9c028;
}
.resultados-title-white {
  color: #ffffff;
}
.resultados-title-last {
  margin-bottom: clamp(20px, 3vh, 36px);
}
.resultados-panel {
  width: min(100%, 760px);
  margin: 0 auto;
}
.resultados-question-list {
  display: grid;
  gap: 12px;
}
.list-item {
  background-color: transparent !important;
  color: #ffffff;
}
.resultados-question-item {
  min-height: 58px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 16px;
  background: rgba(4, 8, 18, 0.55) !important;
  backdrop-filter: blur(2px);
  cursor: pointer;
  transition: transform 0.16s ease, border-color 0.16s ease, background 0.16s ease;
}
.resultados-question-item:hover {
  border-color: #f9c028;
  background: rgba(249, 192, 40, 0.13) !important;
  transform: translateY(-2px);
}
.resultados-question-text {
  color: #ffffff;
  font-size: clamp(16px, 2vw, 22px);
  font-weight: 900;
  white-space: normal;
  line-height: 1.2;
  text-align: center;
}
.resultados-results-heading {
  margin-bottom: 8px;
}
.resultados-subtitle {
  max-width: 920px;
  margin: 0 auto 14px;
  color: #ffffff;
  font-size: clamp(18px, 2.4vw, 28px);
  line-height: 1.15;
  font-weight: 900;
  text-transform: uppercase;
  text-shadow: 0 4px 14px rgba(0, 0, 0, 0.55);
}
.resultados-back-btn {
  margin-bottom: 20px;
  color: #161616 !important;
  font-weight: 900;
}
.resultados-ranking {
  width: min(100%, 1180px);
  max-height: none;
  margin: 0 auto;
  overflow: visible;
  padding: 0 8px 8px;
}
.resultados-ranking-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}
.result-card {
  width: 100%;
  min-height: 98px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(4, 8, 18, 0.62) !important;
  color: #ffffff;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.24);
}
.result-position {
  width: 46px;
  height: 46px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f9c028;
  color: #171717;
  font-size: 24px;
  font-weight: 900;
}
.result-avatar {
  margin-right: 14px !important;
  border: 2px solid rgba(249, 192, 40, 0.7);
}
.result-name {
  color: #ffffff;
  font-size: clamp(19px, 2.4vw, 28px);
  line-height: 1.12;
  font-weight: 900;
  white-space: normal;
}
.result-votes {
  color: #f9c028 !important;
  font-size: clamp(15px, 1.9vw, 20px);
  font-weight: 800;
}
@media (max-width: 599px) {
  .container-login {
    padding: 10px;
  }
  .resultados-row {
    min-height: calc(100vh - 20px);
    min-height: calc(100dvh - 20px);
  }
  .resultados-card {
    min-height: calc(100vh - 20px);
    min-height: calc(100dvh - 20px);
  }
  .resultados-logo {
    width: min(300px, 78vw);
    max-height: 145px;
  }
  .resultados-ranking {
    max-height: none;
  }
  .resultados-ranking-list {
    grid-template-columns: 1fr;
  }
  .result-position {
    width: 38px;
    height: 38px;
    margin-right: 8px;
    font-size: 20px;
  }
  .result-avatar {
    margin-right: 10px !important;
  }
}
a {
  text-decoration: none;
}
</style>
